import { useCallback, useEffect, useState } from "react";
import { api } from "../../../lib/api";
import { useAuth } from "../../../providers/AuthProvider";

export type PurchaseOrderDetail = Awaited<ReturnType<typeof api.purchaseOrders.getPO>>;

export function usePurchaseOrder(id: string | undefined) {
  const { token } = useAuth();
  const [po, setPo] = useState<PurchaseOrderDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    if (!token || !id) return;
    setLoading(true);
    setError(null);
    try {
      const res = await api.purchaseOrders.getPO({ token, id });
      setPo(res);
    } catch (e) {
      setPo(null);
      setError(e instanceof Error ? e.message : "Failed to load purchase order");
    } finally {
      setLoading(false);
    }
  }, [token, id]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { po, loading, error, reload };
}
